var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button as RebassButton } from 'rebass';
import classnames from 'classnames';
var Button = React.forwardRef(function (_a, ref) {
    var showWhenDisabled = _a.showWhenDisabled, active = _a.active, hover = _a.hover, fullWidth = _a.fullWidth, large = _a.large, block = _a.block, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, props = __rest(_a, ["showWhenDisabled", "active", "hover", "fullWidth", "large", "block", "variant"]);
    var hideIfDisabled = ['icon', 'headerIcon', 'secondaryHeaderIcon'].includes(variant) && !showWhenDisabled;
    var notAllowed = props.disabled || (!props.onClick && !props.href);
    return (React.createElement(RebassButton, __assign({ as: "button", variant: "button." + variant, className: classnames({ active: active, hover: hover, large: large, disabled: props.disabled }), ref: ref, sx: __assign(__assign({}, (block ? { borderRadius: 0 } : {})), { alignSelf: 'center', cursor: notAllowed ? 'not-allowed' : 'pointer', letterSpacing: 0, outline: 0, position: 'relative', transition: 'all .2s ease', '&:disabled, &.disabled': {
                boxShadow: 'none',
                display: hideIfDisabled ? 'none' : undefined,
            }, width: fullWidth ? '100%' : null }) }, props)));
});
export default Button;
